var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLightbulbOutlineBlack24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 24 0 24"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test-illustrations-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "api-solutions",
    transform: "translate(-711.000000, -2780.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_lightbulb_outline_black_24px",
    transform: "translate(706.000000, 2778.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,21 C9,21.55 9.45,22 10,22 L14,22 C14.55,22 15,21.55 15,21 L15,20 L9,20 L9,21 Z M12,2 C8.14,2 5,5.14 5,9 C5,11.38 6.19,13.47 8,14.74 L8,17 C8,17.55 8.45,18 9,18 L15,18 C15.55,18 16,17.55 16,17 L16,14.74 C17.81,13.47 19,11.38 19,9 C19,5.14 15.86,2 12,2 Z M14.85,13.1 L14,13.7 L14,16 L10,16 L10,13.7 L9.15,13.1 C7.8,12.16 7,10.63 7,9 C7,6.24 9.24,4 12,4 C14.76,4 17,6.24 17,9 C17,10.63 16.2,12.16 14.85,13.1 Z",
    id: "Shape",
    fill: "#0033AD",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightbulbOutlineBlack24Px);
export default __webpack_public_path__ + "static/media/ic-lightbulb-outline-black-24-px.4c9fb4cd0382ebeb01d033d080bbeaca.svg";
export { ForwardRef as ReactComponent };